import { Component } from '@angular/core';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { DashboardMessagingConstants } from '../../../../core/constants/messaging.constants';

@Component({
	selector: 'ms-dashboard-no-active-org-prompt',
	imports: [FaDuotoneIconComponent],
	templateUrl: './dashboard-no-active-org-prompt.component.html',
	styleUrl: './dashboard-no-active-org-prompt.component.scss'
})
export class DashboardNoActiveOrgPromptComponent {

	public message = DashboardMessagingConstants.DASHBOARD_NO_ACTIVE_ORGANIZATION();
}
